<template>
  <div class="banner">
    <v-carousel cycle height="350" hide-delimiter-background show-arrows-on-hover>
      <v-carousel-item v-for="(slide, idx) in slides" :key="idx">
        <v-sheet :color="colors[idx]" class="lighten-4" height="100%">
          <v-row class="fill-height" align="center" justify="center">
            <div class="display-1">{{ slide }} Slide</div>
          </v-row>
        </v-sheet>
      </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>
export default {
  name: 'banner',
  data() {
    return {
      colors: [
        'indigo',
        'orange',
        'pink'
      ],
      slides: [
        'First',
        'Second',
        'Third'
      ]
    }
  }
}
</script>